// DownloadSection.js
import React, { useRef, useCallback } from 'react';
import * as htmlToImage from 'html-to-image';

function DownloadSection() {
  // 1. Create a ref to reference the DOM element you want to capture
  const domEl = useRef(null);

  const downloadImage = useCallback(async () => {
    if (domEl.current) {
      try {
        // 2. Convert the DOM element to a data URL (PNG format)
        const dataUrl = await htmlToImage.toPng(domEl.current);

        // 3. Create a temporary anchor link for downloading
        const link = document.createElement('a');
        link.download = 'downloaded-image.png'; // Set the download file name
        link.href = dataUrl;

        // 4. Programmatically click the link to trigger the download
        link.click();
      } catch (err) {
        console.error('oops, something went wrong!', err);
      }
    }
  }, []);

  return (
    <div>
      {/* 5. Attach the ref to the specific section you want to download */}
      <div ref={domEl} style={{ padding: '20px', border: '2px solid #ccc' }}>
        <h3>Section to Download</h3>
        <p>This entire div, including its text and styling, will be saved as a PNG file.</p>
        <div style={{ backgroundColor: '#f0f0f0', padding: '10px' }}>
          <p>This is a nested element.</p>
        </div>
      </div>
      
      {/* 6. Add a button to trigger the download function */}
      <button onClick={downloadImage} style={{ marginTop: '10px' }}>
        Download as PNG
      </button>
    </div>
  );
}

export default DownloadSection;
